import React from 'react';

const BankAccountDetails = (props) => {
	const {
		onChangeHandler,
		SelectedFormState,
		interviewDetails,
		validationErrors,
		acctNumError,
		RequiredFields
	} = props;

	return (
		<div>
			<div className="appDivider" />
			<h5 style={{ color: '#666' }} className="">
				Account Details
			</h5>
			<div className="appDivider" />

			<div className="formWrapper">
				<div className="row">
					<div className="col-md-3 col-xs-12 ">
						<label className="appFormLabel">
							Do you have account with SIB?
						</label>
					</div>
					<div className="col-md-4 col-xs-12" style={{ top: '12px' }}>
						<label className="radio-inline">
							<input
								onChange={onChangeHandler}
								className="space"
								type="radio"
								name="AccountWithSib"
								value="true"
								checked={SelectedFormState.AccountWithSib === 'true'}
								disabled={interviewDetails.editable === false ? true : false}
							/>Yes
						</label>
						<label className="radio-inline">
							<input
								onChange={onChangeHandler}
								className="space"
								type="radio"
								name="AccountWithSib"
								value="false"
								checked={SelectedFormState.AccountWithSib === 'false'}
								disabled={interviewDetails.editable === false ? true : false}
							/>No
						</label>
					</div>
				</div>
			</div>

			{
				SelectedFormState.AccountWithSib === 'true' ? (
					<div>
						<div className="formWrapper">
							<div className="row">
								<div className="col-md-3 col-xs-12">
									<label className="appFormLabel">
										<span className="requiredText">*</span>
										Account No
									</label>
								</div>
								<div className="col-md-4 col-xs-12">
									<input
										className="form-control z-depth-3"
										onChange={onChangeHandler}
										value={SelectedFormState.AcctNO}
										name="AcctNO"
										type="password"
										maxLength="20"
										disabled={interviewDetails.editable === false ? true : false}
									/>
									{validationErrors.AcctNOError ? (
										<p className="RoundValidationError">
											<i className="fa fa-warning warningIcon" />&nbsp; Please enter a valid account
											number
										</p>
									) : (
										''
									)}
									{RequiredFields.commonErrors[0].AcctNOReqError ? (
										<p className="RoundValidationError">
											<i className="fa fa-warning warningIcon" />&nbsp; This field cannot be empty
										</p>
									) : null}
								</div>
							</div>
						</div>
						{interviewDetails.editable ? (
							<div className="formWrapper">
								<div className="row">
									<div className="col-md-3 col-xs-12">
										<label className="appFormLabel">
											<span className="requiredText">*</span>
											Confirm Account No
										</label>
									</div>
									<div className="col-md-4 col-xs-12">
										<input
											className="form-control z-depth-3"
											onChange={onChangeHandler}
											value={SelectedFormState.ConfirmAcctNo}
											name="ConfirmAcctNo"
											type="password"
											maxLength="20"
											disabled={interviewDetails.editable === false ? true : false}
										/>
										{validationErrors.ConfirmAcctNoError ? (
											<p className="RoundValidationError">
												<i className="fa fa-warning warningIcon" />&nbsp; Please enter a valid
												account number
											</p>
										) : (
											''
										)}
										{acctNumError ? (
											<p className="RoundValidationError">
												<i className="fa fa-warning warningIcon" />&nbsp; Account number didn't
												match
											</p>
										) : (
											''
										)}
									</div>
								</div>
							</div>
						) : null}
						<div className="formWrapper">
							<div className="row">
								<div className="col-md-3 col-xs-12">
									<label className="appFormLabel">
										<span className="requiredText">*</span>
										IFSC Code
									</label>
								</div>
								<div className="col-md-4 col-xs-12">
									<input
										className="form-control z-depth-3"
										onChange={onChangeHandler}
										value={SelectedFormState.IfscCode}
										name="IfscCode"
										type="text"
										maxLength="15"
										disabled={interviewDetails.editable === false ? true : false}
									/>
									{RequiredFields.commonErrors[0].IfscCodeReqError ? (
										<p className="RoundValidationError">
											<i className="fa fa-warning warningIcon" />&nbsp; This field cannot be empty
										</p>
									) : null}
								</div>
							</div>
						</div>
					</div>
				) : null
			}
		</div >
	);
};

export default BankAccountDetails;
